import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

/* Styles */
import './index.css'

export const MODE = {
  NONE: 0,
  SELECTED: 1,
  PARENT: 2,
  CHILD: 3,
}

/* Single Playlist List Item */
export class Highlight extends Component {

    getClassName() {
      const {
        className,
        mode
      } = this.props
      let classNameArr = className ?className.split(' '):[]
      classNameArr.push('highlight', 'widget')
      switch (mode) {
        case MODE.SELECTED:
          classNameArr.push('selected')
          break
        case MODE.PARENT:
          classNameArr.push('parent')
          break
        case MODE.CHILD:
          classNameArr.push('child')
          break
      }
      return  classNameArr.join(' ')
    }

    render() {
      const {
        uid,
        onClick,
        onFocus
      } = this.props
      return (
        <div className={ this.getClassName() }> </div>
      )
    }
}

Highlight.propTypes = {
  mode: PropTypes.number,
}



// WEBPACK FOOTER //
// ./src/app/widget/highlight/index.jsx